import { render, staticRenderFns } from "./academic-details.vue?vue&type=template&id=610547b2&"
import script from "./academic-details.vue?vue&type=script&lang=js&"
export * from "./academic-details.vue?vue&type=script&lang=js&"
import style0 from "./academic-details.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports